import React from 'react';
import { connect } from 'react-redux';
import './SideNotifications.css';
import Alert from "../Alert/index";

class SideNotifications extends React.Component {
    render() {
        const { notifications } = this.props;
        return (
            <aside id="side-notifications">
                {notifications && notifications.map(({content, title, type}, key) => (
                    <Alert content={content} title={title} type={type} key={key} />
                ))}
            </aside>
        )
    }
}

const mapStateToProps = state => {
    return { notifications: state.notifications };
};

const mapDispatchToProps = (dispatch) => {
    return { dispatch };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(SideNotifications);



// WEBPACK FOOTER //
// ./src/components/SideNotifications/index.js